import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from 'react';

interface LoaderContextType {
  showLoader: boolean;
  setShowLoader: (value: boolean) => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const value = useMemo(() => ({ showLoader, setShowLoader }), [showLoader]);
  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
};

export const useLoader = (): LoaderContextType => {
  const context = useContext(LoaderContext);
  if (!context) {
    return { showLoader: false, setShowLoader: () => {} };
  }
  return context;
};
